import { useState, useEffect, useRef } from "react";
import debounce from "lodash.debounce";
import CommonService from "@/services/api/CommonService";

export default function useSearchCourses() {
  const [searchText, setSearchText] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const wrapperRef = useRef();

  const searchCourses = debounce(async (text) => {
    if (text.length < 2) {
      setSuggestions([]);
      return;
    }
    try {
      const results = await CommonService.searchCourses(text);
      setSuggestions(results || []);
      setShowDropdown(true);
    } catch (error) {
      console.error("Search failed:", error);
    }
  }, 300);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchText(value);
    searchCourses(value);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return {
    searchText,
    setSearchText,
    suggestions,
    setSuggestions,
    showDropdown,
    setShowDropdown,
    wrapperRef,
    handleInputChange,
  };
}
